import React, { useEffect, useMemo, useState } from 'react';
import { Progress, Rate } from 'tea-component';
// import AppstoreIcon from '@/pages/opinion/assets/svg/channel/app_store.svg';
// import GoogleplayIcon from '@/pages/opinion/assets/svg/channel/google_play.svg';
// import TaptapIcon from '@/pages/opinion/assets/svg/channel/taptap.svg';
// import Xbox from '@/pages/opinion/assets/svg/channel/xbox.svg';
import moment from 'moment';
import BubbleCommon, {
  gameStoreAppleStoreTableHeaderTips,
  gameStoreReviewsTips,
  lifeTimeText,
  selectedText,
} from '@/pages/opinion/components/BubbleCommon';
import { useHistory, useIntl } from 'umi';
// import NoDataCommon from '../NoDataCommon';
// import { getPercentageValue, getShowCount } from '../../utils';
// import StarNum from '../StarBubble/StarNum';
// import StarBubble from '../StarBubble';

// import './index.scss';
import NoDataCommon from '@op/components/NoDataCommon';
import StarBubble from '@op/components/StarBubble';
import StarNum from '@op/components/StarBubble/StarNum';
import { getPercentageValue, getShowCount } from '@op/utils';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import { NO_DATE } from '@op/constants';
// import { goStatsDetailAction } from '../../pages/stats/Detail';
// import { NO_DATE } from '../../constants';

// 代码从舆情迁移
export default function UserScoreBox(props: any) {
  const { formatMessage } = useIntl();
  const {
    type,
    filter,
    platform,
    data,
    isFeeds,
    isHeader,
    height = 174,
    title
  } = props;

  const { start_time, end_time } = filter || {};

  // 假设 start_time 和 end_time 是 Moment 对象或者能被 Moment 解析的日期格式
  const yesterday = moment().subtract(1, 'day');
  const today = moment();

  const isStartWithinPeriod = moment(start_time).isBetween(
    yesterday,
    today,
    'day',
    '[]',
  );
  const isEndWithinPeriod = moment(end_time).isBetween(
    yesterday,
    today,
    'day',
    '[]',
  );

  const isFlag = isStartWithinPeriod && isEndWithinPeriod;

  // 特殊处理 app store 的标题
  const getTitle = () => {
    if (platform === 'app store' && type === 'selected' && isFlag) {
      return 'Selected AVG. Rating (T-2)';
    }
    return 'Selected AVG. Rating';
  };

  // 特殊处理 app store 的标题，需要增加一个提示
  const getIcon = () => {
    if (platform === 'app store' && type === 'selected' && isFlag) {
      return (
        <>
          <BubbleCommon
            tipsMap={gameStoreAppleStoreTableHeaderTips}
            dark
          ></BubbleCommon>
        </>
      );
    }
    return '';
  };

  const [mentions, detail, score, latestTime, scoreText] = useMemo(() => {
    const { mentions, detail, score, latest_time } = data || {};
    return [
      mentions || 0,
      detail || { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      score || 0,
      latest_time || '',
      score?.toFixed(1),
    ];
  }, [data]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [scoreDate, setScoreDate] = useState('');

  useEffect(() => {
    let time = '';
    if (type === 'lifetime') {
      time = latestTime;
      if (platform === 'taptap' && !time) {
        if (end_time) {
          time = `Up to ${moment(end_time).format('YYYY-MM-DD')}`;
        }
      }
    } else {
      if (end_time) {
        if (platform === 'app store' && isFlag) {
          time = moment().subtract(2, 'days').format('YYYY-MM-DD');
        } else {
          if (moment(start_time).isSame(end_time, 'd')) {
            time = moment(start_time).format('YYYY-MM-DD');
          } else {
            time = `${moment(start_time).format('YYYY-MM-DD')} to ${moment(
              end_time,
            ).format('YYYY-MM-DD')}`;
          }
        }
      }
    }

    setScoreDate(time);
  }, [latestTime]);

  const history = useHistory();

  return (
    <div className="dbo-scorebox">
      {!isHeader ? (
        <div className="dbo-scorebox-hd">
          <BubbleCommon
            showIcon={false}
            placement="top"
            dark
            tipsMap={type === 'lifetime' ? lifeTimeText : selectedText}
          >
            <div className="dbo-scorebox-hd-text">
              <div className="dbo-scorebox-hd-tit">
                {title || formatMessage({
                  id:
                    type === 'lifetime' ? 'Lifetime Accum. Rating' : getTitle(),
                })}
              </div>
            </div>
          </BubbleCommon>
          {getIcon()}
        </div>
      ) : null}
      {score === 0 ? (
        <NoDataCommon
          hasDesc={false}
          hasImg={false}
          hasTitle
          emptyTitleText={NO_DATE.SELECTION}
          style={{ height }}
        ></NoDataCommon>
      ) : (
        <div className="dbo-scorebox-bd">
          <div className="dbo-scorebox-content">
            <div className="dbo-scorebox-score">
              <div className="dbo-scorebox-num">{scoreText}</div>
              {/* <div className="dbo-scorebox-updown">
                <span className="dbo-scorebox-updown-text">63.37%</span>
                <SvgIcon
                  type={true ? 'rising-arrow-icon' : 'down-arrow-icon'}
                  className="dbo-scorebox-updown-icon"
                />
              </div> */}
            </div>
            <div className="dbo-scorebox-reviewbox">
              <Rate
                readonly
                theme="primary"
                allowHalf
                value={score}
              />
              <BubbleCommon
                placement="right"
                tipsMap={
                  platform === 'google play' && type === 'lifetime'
                    ? gameStoreReviewsTips
                    : null
                }
                showIcon={false}
              >
                <div className="dbo-scorebox-text">
                  {getShowCount(mentions)}{' '}
                  {formatMessage({
                    id: type === 'lifetime' ? 'Ratings-1' : 'Reviews-1',
                  })}
                </div>
              </BubbleCommon>
            </div>
          </div>

          <StarBubble
            isLifetime={type === 'lifetime'}
            detail={detail}
            mentions={mentions}
          >
            <div className="dbo-scorebox-subcontent">
              <StarNum />
              <div className="dbo-scorebox-progressbox">
                {[5, 4, 3, 2, 1].map((star) => (
                  <Progress
                    key={star}
                    className={`dbo-scorebox-progress star${star}`}
                    percent={getPercentageValue(detail[star], mentions) * 100}
                    strokeWidth={4}
                    onClick={() => {
                      if (isFeeds) {
                        return;
                      }
                      goStatsDetailAction({
                        path: `/opinion/Feeds/Feeds?tab=gameStore`,
                        params: {
                          statsDetailType: 'feeds-gameStoreLine',
                          ...filter,
                          channel: [platform],
                          channel_type: 'comments',
                          reviews_rating: [`${  star}`],
                        },
                        history,
                      });
                    }}
                  />
                ))}
              </div>
            </div>
          </StarBubble>

          {/* <div className="dbo-scorebox-desinfo">{scoreDate}</div> */}
        </div>
      )}
    </div>
  );
}
